import { c as _c } from "react/compiler-runtime";
import { Box, Center, chakra, HStack, Icon, Link, Popover, Portal, Text } from '@chakra-ui/react';
import { GroupEvent } from '@src/graphql-types';
import moment from 'moment';
import React from 'react';
import { LuCheck } from 'react-icons/lu';
type CalendarEventCardProps = {
  event: GroupEvent;
  onShowDetails?: (event: GroupEvent) => void;
};
export const CalendarEventCard = props => {
  const $ = _c(28);
  const t0 = props.event.type.colorHexCode ? `${props.event.type.colorHexCode}80` : "whiteAlpha.50";
  const t1 = props.event.type.colorHexCode ? `${props.event.type.colorHexCode}` : "whiteAlpha.50";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      color: "white",
      bgColor: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `4px solid ${props.event.type.colorHexCode ? `${props.event.type.colorHexCode}` : "whiteAlpha.50"}`;
  const t4 = `/events/${props.event.groupEventId}`;
  let t5;
  if ($[2] !== props) {
    t5 = ev => {
      ev.preventDefault();
      props.onShowDetails?.(props.event);
      return false;
    };
    $[2] = props;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== props.event.startsAt) {
    t6 = moment(props.event.startsAt).format("h:mm A");
    $[4] = props.event.startsAt;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = props.event.type?.title;
  let t8;
  if ($[6] !== t7) {
    t8 = <chakra.span borderLeft="1px dotted" borderLeftColor="colorPalette.fg/50" color="colorPalette.fg/80" display="inline-block" fontWeight="600" lineHeight={1} marginLeft={2} paddingLeft={2}>{t7}</chakra.span>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t6 || $[9] !== t8) {
    t9 = <Box alignItems="flex-start" flexGrow={1} flexShrink={0} marginY="4px" opacity={0.8}><Text color="colorPalette.fg" fontSize="2xs" textStyle="label">{t6}{t8}</Text></Box>;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== props.event.isCurrentUserAttending) {
    t10 = props.event.isCurrentUserAttending && <Box fontSize="12px"><Popover.Root><Popover.Trigger asChild={true}><Icon asChild={true} color="colorPalette.fg"><LuCheck /></Icon></Popover.Trigger><Portal><Popover.Positioner><Popover.Content><Popover.Arrow /><Popover.Body><Center><Text>You're registered to attend!</Text></Center></Popover.Body></Popover.Content></Popover.Positioner></Portal></Popover.Root></Box>;
    $[11] = props.event.isCurrentUserAttending;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <HStack alignItems="space-between" gap="1">{t9}{t10}</HStack>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== props.event.title) {
    t12 = <Box marginY={1} width="full"><Text color="colorPalette.fg" fontWeight="semibold" textStyle="xs">{props.event.title}</Text></Box>;
    $[16] = props.event.title;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12 || $[20] !== t4 || $[21] !== t5) {
    t13 = <a href={t4} onClick={t5}>{t11}{t12}</a>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t4;
    $[21] = t5;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t0 || $[24] !== t13 || $[25] !== t2 || $[26] !== t3) {
    t14 = <><Link asChild={true} bgColor={t0} borderRadius="0.125em" boxShadow="sm" cursor="pointer" display="block" marginBottom="4px" padding="2" textDecoration="none" transition="all .2s ease-in-out" _hover={t2} borderLeft={t3}>{t13}</Link></>;
    $[23] = t0;
    $[24] = t13;
    $[25] = t2;
    $[26] = t3;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};